import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

function Head({ title, description, imageUrl, favIcon = '' }) {
    setSiteFavicon(favIcon);
    return (
        <Helmet>
            <title>{title || 'Feversocial Form'}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:description" content={description} />
            {!favIcon && (
                <link
                    rel="icon"
                    href="https://assets.fevercdn.com/forms/form_favicon.png"
                    type="image/gif"
                    sizes="16x16"
                />
            )}
        </Helmet>
    );
}

Head.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    favIcon: PropTypes.string
};

export default Head;

export function setSiteFavicon(favIconUrl) {
    const selectorFavicon = document.querySelector("link[rel='shortcut icon']");
    if (selectorFavicon !== null && Boolean(favIconUrl)) {
        selectorFavicon.href = favIconUrl;
    }
}
